import { FormProvider, useForm } from 'react-hook-form';

function FormProviderWrapper({ children }) {
    const methods = useForm();

    return <FormProvider {...methods}>{children}</FormProvider>;
}

export default FormProviderWrapper;
